import { render } from "./desktop-view.vue?vue&type=template&id=1f04b8e7&scoped=true&ts=true"
import script from "./desktop-view.vue?vue&type=script&lang=ts"
export * from "./desktop-view.vue?vue&type=script&lang=ts"

import "./desktop-view.vue?vue&type=style&index=0&id=1f04b8e7&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/t3_d_M4E/0/hellmanh/rb-app-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f04b8e7"]])

export default __exports__